/* ============================================================
   case-select-recommend-set — 交互脚本(defer)
   左半:ModelSelect / ModelSelectPopup(机种选择器,交互复用自主题既有选择器,去 yg 命名)
   右半:RecommendSet(おすすめセット推荐组:组循环切换 + 整组批量加购 + 打开主题购物车抽屉)
   注:加购成功镜像主题 xo-webcomponents 的 addCartMultiSuccess 契约(柯里化 xoStore.set)
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- 左半:机种选择器 ---------------- */
  class ModelSelect extends HTMLElement {
    constructor() {
      super();
      this.currentTypeIndex = 0;
      this.currentOptionUrl = null;
      this._isMobileMode = null;
      this._itemTypeHandler = (e) => this.itemClick(e, 'item-type');
      this._itemOptionHandler = (e) => this.itemClick(e, 'item-option');
      this._optionTitleHandler = (e) => this.optionClick(e, 'item-type');
      this._optionContentsHandlers = new Map();
      this._handleDocumentClick = (e) => this.clone(e);
      this._handleResize = () => this.initEventMode();
      this._mobileClickHandler = () => this.openPopup();
    }

    get sectionEl() {
      if (this._sectionEl) return this._sectionEl;

      this._sectionEl = {
        'item-type': this.querySelector('.model-select__inner-content-item.item-type'),
        'item-type-image': this.querySelector('.model-select__inner-content-item.item-type .model-select__inner-content-item-image-img img'),
        'item-type-title': this.querySelector('.model-select__inner-content-item.item-type .model-select__inner-content-item-text-title'),
        'option-title': this.querySelector('.model-select__inner-content-item-options.option-title'),
        'item-option': this.querySelector('.model-select__inner-content-item.item-option'),
        'item-option-image': this.querySelector('.model-select__inner-content-item.item-option .model-select__inner-content-item-image-img img'),
        'item-option-title': this.querySelector('.model-select__inner-content-item.item-option .model-select__inner-content-item-text-title'),
        'option-contents': this.querySelectorAll('.model-select__inner-content-item-options.option-content'),
        button: this.querySelector('.model-select__inner-content-item-button'),
      };

      return this._sectionEl;
    }

    connectedCallback() {
      // 根据屏幕宽度决定桌面/移动交互;移动端点击整块打开底部弹窗
      this.initEventMode();

      if (this.sectionEl['button']) {
        this.sectionEl['button'].addEventListener('click', () => this.redirectToSelectedCollection());
      }

      document.addEventListener('click', this._handleDocumentClick);
      window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._handleDocumentClick);
      window.removeEventListener('resize', this._handleResize);
      this.disableDesktopMode();
      this.removeEventListener('click', this._mobileClickHandler);
    }

    initEventMode() {
      const isMobile = window.innerWidth < 550;
      if (isMobile && this._isMobileMode) return;
      if (!isMobile && this._isMobileMode === false) return;

      if (isMobile) {
        this.disableDesktopMode();
        this.addEventListener('click', this._mobileClickHandler);
        this._isMobileMode = true;
      } else {
        this.removeEventListener('click', this._mobileClickHandler);
        this.enableDesktopMode();
        this._isMobileMode = false;
      }
    }

    enableDesktopMode() {
      if (this.sectionEl['item-type']) {
        this.sectionEl['item-type'].addEventListener('click', this._itemTypeHandler);
      }
      if (this.sectionEl['item-option']) {
        this.sectionEl['item-option'].addEventListener('click', this._itemOptionHandler);
      }
      if (this.sectionEl['option-title']) {
        this.sectionEl['option-title'].addEventListener('click', this._optionTitleHandler);
      }
      if (this.sectionEl['option-contents']) {
        this.sectionEl['option-contents'].forEach((contentEl) => {
          const handler = (e) => this.optionClick(e, 'item-option');
          this._optionContentsHandlers.set(contentEl, handler);
          contentEl.addEventListener('click', handler);
        });
      }
    }

    disableDesktopMode() {
      if (this.sectionEl['item-type']) {
        this.sectionEl['item-type'].removeEventListener('click', this._itemTypeHandler);
      }
      if (this.sectionEl['item-option']) {
        this.sectionEl['item-option'].removeEventListener('click', this._itemOptionHandler);
      }
      if (this.sectionEl['option-title']) {
        this.sectionEl['option-title'].removeEventListener('click', this._optionTitleHandler);
      }
      if (this._optionContentsHandlers && this._optionContentsHandlers.size) {
        this._optionContentsHandlers.forEach((handler, contentEl) => {
          contentEl.removeEventListener('click', handler);
        });
        this._optionContentsHandlers.clear();
      }
    }

    openPopup() {
      const section = this.closest('.shopify-section');
      if (!section) return;
      const popup = section.querySelector('model-select-popup');
      if (!popup || typeof popup.showPopup !== 'function') return;

      const loadingEl = section.querySelector('.model-select__loading');

      if (loadingEl && popup.style.display !== 'block' && !popup.classList.contains('open')) {
        loadingEl.classList.add('show');
      }

      popup.showPopup();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (loadingEl) loadingEl.classList.remove('show');
        });
      });
    }

    itemClick(e, type) {
      if (e.target.closest('.model-select__inner-content-item-options')) return;

      if (type === 'item-type') {
        this.sectionEl['option-title'].classList.toggle('active');
      }

      if (type === 'item-option') {
        this.sectionEl['option-contents'][this.currentTypeIndex].classList.toggle('active');
      }
    }

    optionClick(e, type) {
      const currentItem = e.target.closest('.model-select__inner-content-item-options-item');
      if (!currentItem || currentItem.classList.contains('active')) return;

      const parentElement = currentItem.parentElement;
      const siblings = Array.from(currentItem.parentNode.children).filter((el) => el !== currentItem);
      siblings.forEach((sibling) => sibling.classList.remove('active'));
      currentItem.classList.add('active');
      parentElement.classList.remove('active');

      if (type === 'item-type') {
        this.sectionEl['option-contents'][this.currentTypeIndex].classList.remove('active');
        this.currentTypeIndex = currentItem.getAttribute('data-index');
        const currentActiveOption = this.sectionEl['option-contents'][this.currentTypeIndex].querySelector('.model-select__inner-content-item-options-item.active');
        this.currentOptionUrl = currentActiveOption ? currentActiveOption.getAttribute('data-url') : null;

        if (currentActiveOption) this.updataEl('item-option', currentActiveOption);
      }

      if (type === 'item-option') {
        this.currentOptionUrl = currentItem.getAttribute('data-url');
      }

      this.updataEl(type, currentItem);
    }

    updataEl(type, el) {
      const textEl = el.querySelector('.model-select__inner-content-item-options-item-text');
      const imageEl = el.querySelector('.model-select__inner-content-item-options-item-image img');
      if (type === 'item-type') {
        if (textEl && this.sectionEl['item-type-title']) this.sectionEl['item-type-title'].textContent = textEl.textContent;
        if (imageEl && this.sectionEl['item-type-image']) this.sectionEl['item-type-image'].src = imageEl.src;
      }
      if (type === 'item-option') {
        if (textEl && this.sectionEl['item-option-title']) this.sectionEl['item-option-title'].textContent = textEl.textContent;
        if (imageEl && this.sectionEl['item-option-image']) this.sectionEl['item-option-image'].src = imageEl.src;
      }
    }

    clone(e) {
      if (e.target.closest('.model-select__inner-content')) return;
      if (this.sectionEl['option-title']) {
        this.sectionEl['option-title'].classList.remove('active');
      }
      if (this.sectionEl['option-contents']) {
        this.sectionEl['option-contents'].forEach((contentEl) => {
          contentEl.classList.remove('active');
        });
      }
    }

    redirectToSelectedCollection() {
      let url = this.currentOptionUrl;
      if (!url) {
        const contents = this.sectionEl['option-contents'][this.currentTypeIndex];
        const activeItem = contents ? contents.querySelector('.model-select__inner-content-item-options-item.active') : null;
        if (activeItem) {
          url = activeItem.getAttribute('data-url');
          this.currentOptionUrl = url;
        }
      }

      if (this.currentOptionUrl) window.location.href = this.currentOptionUrl;
    }
  }
  if (!window.customElements.get('model-select')) {
    window.customElements.define('model-select', ModelSelect);
  }

  /* ---------------- 左半:移动底部弹窗 ---------------- */
  class ModelSelectPopup extends HTMLElement {
    constructor() {
      super();
      this.closeOverlay = this.closeOverlay.bind(this);
      this._onKeydown = (e) => {
        if (e.key === 'Escape') this.hidePopup();
      };
    }

    connectedCallback() {
      this.addEventListener('click', this.closeOverlay);
      const popupInfo = this.querySelector('.model-select__popup-info');
      if (popupInfo) {
        popupInfo.addEventListener('click', (e) => e.stopPropagation());
      }
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closeOverlay);
      document.removeEventListener('keydown', this._onKeydown);
    }

    closeOverlay(e) {
      if (!this.classList.contains('open')) return;
      const popupInfo = this.querySelector('.model-select__popup-info');
      if (popupInfo && popupInfo.contains(e.target)) return;
      this.hidePopup();
    }

    hidePopup() {
      this.style.display = 'none';
      this.classList.remove('open');
      document.documentElement.style.overflow = '';
    }

    showPopup() {
      this.style.display = 'block';
      document.documentElement.style.overflow = 'hidden';
      this.classList.add('open');
    }
  }
  if (!window.customElements.get('model-select-popup')) {
    window.customElements.define('model-select-popup', ModelSelectPopup);
  }

  /* ---------------- 右半:おすすめセット 推荐组 ---------------- */
  class RecommendSet extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this._onRefresh = () => this.handleRefresh();
      this._onCart = () => this.handleAddToCart();
    }

    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.recommend-set__group'));
      this.refreshBtn = this.querySelector('.recommend-set__btn--refresh');
      this.cartBtn = this.querySelector('.recommend-set__btn--cart');

      if (this.refreshBtn) this.refreshBtn.addEventListener('click', this._onRefresh);
      if (this.cartBtn) this.cartBtn.addEventListener('click', this._onCart);

      this.showGroup(0);
    }

    disconnectedCallback() {
      if (this._spinTimer) clearTimeout(this._spinTimer);
      if (this.refreshBtn) this.refreshBtn.removeEventListener('click', this._onRefresh);
      if (this.cartBtn) this.cartBtn.removeEventListener('click', this._onCart);
    }

    showGroup(i) {
      const n = this.groups.length;
      if (!n) return;
      this.currentIndex = ((i % n) + n) % n;
      this.groups.forEach((group, idx) => {
        group.classList.toggle('is-hidden', idx !== this.currentIndex);
      });
      this.updateCartState();
    }

    handleRefresh() {
      if (this.groups.length < 2) return;
      if (this.refreshBtn) {
        this.refreshBtn.classList.add('is-spin');
        if (this._spinTimer) clearTimeout(this._spinTimer);
        this._spinTimer = setTimeout(() => {
          this._spinTimer = null;
          if (this.refreshBtn) this.refreshBtn.classList.remove('is-spin');
        }, 500);
      }
      this.showGroup(this.currentIndex + 1);
    }

    getCurrentVariantIds() {
      const group = this.groups[this.currentIndex];
      if (!group) return [];
      const cards = group.querySelectorAll('.recommend-set__card[data-variant-id]');
      const ids = [];
      cards.forEach((card) => {
        const id = card.getAttribute('data-variant-id');
        if (id) ids.push(id);
      });
      return ids;
    }

    updateCartState() {
      if (!this.cartBtn) return;
      this.cartBtn.disabled = this.getCurrentVariantIds().length === 0;
    }

    getRoutesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // 复刻主题 xo-webcomponents 的 getServiceSections:请求 xo-cart-mini(及 /cart 页的 xo-cart)所属 section,
    // 使 /cart/add.js 返回的 data.sections 的 key 与 xo-cart-mini 消费的 key 一致,加购后抽屉/角标才会实时刷新
    getServiceSections() {
      if (window.Xotiny) {
        const ids = [];
        if (window.location.pathname.includes('/cart')) {
          const cart = document.querySelector('xo-cart');
          if (cart && cart.id) ids.push(cart.id);
        }
        const cartMini = document.querySelector('xo-cart-mini');
        if (cartMini && cartMini.id) ids.push(cartMini.id);
        if (ids.length) return ids;
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    cartErrorText() {
      return this.getAttribute('data-cart-error') || 'カートに追加できませんでした';
    }

    async handleAddToCart() {
      const ids = this.getCurrentVariantIds();
      if (!ids.length || !this.cartBtn || this.cartBtn.disabled) return;

      const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
      const qty = items.length;
      const routesRoot = this.getRoutesRoot();
      this.cartBtn.disabled = true;

      try {
        const res = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            sections: this.getServiceSections(),
            section_url: window.location.pathname,
          }),
        });
        if (!res.ok) throw new Error('add-to-cart-failed');
        const data = await res.json();
        this.syncCartStore(data, ids, qty);
        this.openCartDrawer(routesRoot);
      } catch (err) {
        this.cartBtn.disabled = false;
        this.notifyError();
      }
    }

    // 镜像主题 addCartMultiSuccess:柯里化 xoStore.set，更新 size/sections/isAdded 使角标与抽屉同步
    syncCartStore(data, ids, qty) {
      if (window.xoStore && typeof window.xoStore.set === 'function') {
        try {
          window.xoStore.set('xo-cart', (prev) => ({
            ...prev,
            size: ((prev && prev.size) || 0) + qty,
            sections: data.sections,
            items: data.items,
            addIdLoading: '',
            isAdded: true,
            productIdsForCartNotification: ids.map((id) => `${id}`),
          }))('xo-cart/addCartSuccess');
        } catch (e) {
          // store 形状若变动则静默降级，靠打开抽屉兜底
        }
      }
      this.cartBtn.disabled = false;
    }

    openCartDrawer(routesRoot) {
      const trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
      } else {
        window.location.href = `${routesRoot}cart`;
      }
    }

    notifyError() {
      const msg = this.cartErrorText();
      if (window.xoToast && typeof window.xoToast.push === 'function') {
        window.xoToast.push({ content: msg, className: 'xo-cart-add-error', placement: 'top-center', delay: 4000 });
      } else {
        window.alert(msg);
      }
    }
  }
  if (!window.customElements.get('recommend-set')) {
    window.customElements.define('recommend-set', RecommendSet);
  }
})();
